
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.256 0h-5v5h5V0zM12.756 0h-5v5h5V0zM20.256 0h-5v5h5V0zM5.256 7.504h-5v5h5v-5zM12.756 7.504h-5v5h5v-5zM20.256 7.504h-5v5h5v-5zM5.256 15h-5v5h5v-5zM12.756 15h-5v5h5v-5zM20.256 15h-5v5h5v-5z","fill":"currentColor"}})])
          )
        }
      }
    